export default "__VITE_ASSET__6rDC38V1__"